import type { apiClient } from '~/shared/api/data-ingestion-api'
import type { AuditTrailEventDescriptionField, OnshoreChangeEventProps } from '../../model'
import { collectFieldSearchText } from './searchable-text-utils'

function formatOnshoreValue(value: boolean | null | undefined): string {
  if (value === true) return 'US Only'
  return 'International'
}

export function transformOnshoreChange(event: apiClient.AuditEvent): OnshoreChangeEventProps {
  const fields: AuditTrailEventDescriptionField[] = [
    {
      label: 'Visibility',
      values: [
        {
          previous: formatOnshoreValue(event.prev_onshore_only),
          current: formatOnshoreValue(event.new_onshore_only),
        },
      ],
    },
  ]

  return {
    type: 'onshore-change',
    timestamp: event.timestamp,
    user: event.user,
    userRole: 'person',
    step: 'document',
    eventType: event.event_type,
    title: 'Document visibility changed',
    fields,
    notes: event.notes || null,
  }
}

export function getOnshoreChangeSearchableText(props: OnshoreChangeEventProps): string {
  const parts = [props.title]
  if (props.fields) parts.push(collectFieldSearchText(props.fields))
  if (props.notes) parts.push(props.notes)
  return parts.join(' ')
}
